import { useState } from 'react'
import { useNotification } from '../contexts/NotificationContext'

function LoginScreen({ apiService, onLogin }) {
  const [credentials, setCredentials] = useState({
    username: 'admin',
    password: 'admin123'
  })
  const [isLoading, setIsLoading] = useState(false)
  const { showNotification } = useNotification()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!credentials.username || !credentials.password) {
      showNotification('Inserisci username e password', 'error')
      return
    }

    setIsLoading(true)
    try {
      const loginResponse = await apiService.login(credentials.username, credentials.password)

      if (loginResponse.success) {
        const user = {
          id: loginResponse.user.id,
          username: loginResponse.user.username,
          role: loginResponse.user.role,
          token: loginResponse.token,
          loginTime: new Date().toISOString()
        }

        onLogin(user)
        showNotification(`Accesso effettuato come ${credentials.username} (${loginResponse.user.role})`, 'success')
      } else {
        showNotification('Credenziali non valide', 'error')
      }
    } catch (error) {
      console.error('Login failed:', error)
      showNotification(`Errore durante l'accesso: ${error.message}`, 'error')
    } finally {
      setIsLoading(false)
    }
  }

  const handleChange = (field) => (e) => {
    setCredentials(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }

  return (
    <div className="screen">
      <div 
        className="MuiContainer-root" 
        style={{ maxWidth: '400px', margin: '100px auto', padding: '24px' }}
      >
        <div 
          className="MuiPaper-root MuiCard-root"
          style={{ 
            padding: '32px', 
            borderRadius: '8px', 
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)' 
          }}
        >
          <div 
            className="MuiCardHeader-root" 
            style={{ textAlign: 'center', paddingBottom: '24px' }}
          >
            <h1 
              className="MuiTypography-h4" 
              style={{ margin: 0, color: '#1976d2', fontWeight: 500 }}
            >
              Energy Trade AI Dashboard
            </h1>
          </div>

          <form onSubmit={handleSubmit}>
            <div 
              className="MuiCardContent-root login-form" 
              style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
            >
              <div className="MuiFormControl-root MuiTextField-root">
                <label 
                  className="MuiInputLabel-root"
                  style={{ 
                    color: '#1976d2', 
                    fontWeight: 500, 
                    marginBottom: '8px', 
                    display: 'block' 
                  }}
                >
                  Username
                </label>
                <input 
                  type="text" 
                  className="MuiInputBase-input MuiOutlinedInput-input"
                  placeholder="admin o trader1"
                  value={credentials.username}
                  onChange={handleChange('username')}
                  style={{ 
                    border: '1px solid #ccc', 
                    borderRadius: '4px', 
                    padding: '14px', 
                    width: '100%', 
                    fontSize: '1rem' 
                  }}
                />
              </div>

              <div className="MuiFormControl-root MuiTextField-root">
                <label 
                  className="MuiInputLabel-root"
                  style={{ 
                    color: '#1976d2', 
                    fontWeight: 500, 
                    marginBottom: '8px', 
                    display: 'block' 
                  }}
                >
                  Password
                </label>
                <input 
                  type="password" 
                  className="MuiInputBase-input MuiOutlinedInput-input"
                  placeholder="admin123 o trader123"
                  value={credentials.password}
                  onChange={handleChange('password')}
                  style={{ 
                    border: '1px solid #ccc', 
                    borderRadius: '4px', 
                    padding: '14px', 
                    width: '100%', 
                    fontSize: '1rem' 
                  }}
                />
              </div>

              <button 
                type="submit"
                disabled={isLoading}
                className="MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                style={{ 
                  backgroundColor: isLoading ? '#ccc' : '#1976d2', 
                  color: 'white', 
                  padding: '12px 24px', 
                  border: 'none', 
                  borderRadius: '4px', 
                  cursor: isLoading ? 'not-allowed' : 'pointer', 
                  fontSize: '1rem', 
                  fontWeight: 500, 
                  marginTop: '8px' 
                }}
              >
                {isLoading ? 'Accesso...' : 'Accedi'}
              </button>

              <div style={{ 
                marginTop: '16px', 
                padding: '12px', 
                backgroundColor: '#e3f2fd', 
                borderRadius: '4px', 
                borderLeft: '4px solid #1976d2' 
              }}>
                <p style={{ margin: 0, fontSize: '0.875rem', color: '#1976d2' }}>
                  <strong>Credenziali Test:</strong><br />
                  • admin / admin123 (Amministratore)<br />
                  • trader1 / trader123 (Trader)
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginScreen
